<!--  -->
<template>
  <div class="SubItems">
    <div class="popcategory">
      <div class="imgboxs">
        <img :src="imgArr.aboutImg?ossUrl+imgArr.aboutImg:''" alt="" v-if="activeRoute==1">
        <img :src="imgArr.brandImg?ossUrl+imgArr.brandImg:''" alt="" v-if="activeRoute==2">
        <img :src="imgArr.patentImg?ossUrl+imgArr.patentImg:''" alt="" v-if="activeRoute==3">
        <img :src="imgArr.copyrightImg?ossUrl+imgArr.copyrightImg:''" alt="" v-if="activeRoute==4">
        <img :src="imgArr.iplawImg?ossUrl+imgArr.iplawImg:''" alt="" v-if="activeRoute==5">
        <img :src="imgArr.dynamicsImg?ossUrl+imgArr.dynamicsImg:''" alt="" v-if="activeRoute==6">
      </div>
      <div class="categorywrapper">
        <div class="categorybox">
          <div class="categoryitem" v-for="(item, index) in subItems">
            <div class="title" :class="{ active: activeRoute == index + 1 }">
              <img src="https://oss.sbooip.com/static/www/pc/assets/images/iconred.png" alt="" class="sbooicon " v-if="activeRoute == index + 1">
              <img src="https://oss.sbooip.com/static/www/pc/assets/images/icon.png" alt="" class="sbooicon grey" v-else>
              {{ item.title }}
            </div>
            <template v-for="sub in item.sub">
              <router-link :to="sub.path" active-class="active">
                <div class="subitem" @click="changeActive(index + 1)">{{ sub.name }}</div>
              </router-link>
            </template>
          </div>
        </div>
        <div class="linkbox">
          <router-link to="/BigData/PatentSearch">
            <span class="link" @click.self="changeActive()">专利Ai大数据/年费监控</span>
          </router-link>
          <div></div>
        </div>
      </div>
      <div class="logobg">
        <img src="https://oss.sbooip.com/static/www/pc/assets/images/icon.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex"
export default {
  name: "SubItems",
  components: {},
  data() {
    return {
      subItems: [
        {
          title: '关于我们',
          sub: [
            { name: '公司简介', path: '/About/Company' },
            { name: '发展历程', path: '/About/History' },
            { name: '荣誉资质', path: '/About/Qualification' },
            { name: '团队风采', path: '/About/TeamSpirit' },
            { name: '合作客户', path: '/About/CooperativeClients' },
            { name: '案例展示', path: '/About/CaseShowcase' },
            { name: '人才招聘', path: '/About/TalentRecruitment' }
          ]
        },
        {
          title: '商标注册',
          sub: [
            { name: '查询与设计', path: '/Trademark/SearchDesign' },
            { name: '续展与变更', path: '/Trademark/Renewal' },
            { name: '异议与撤三', path: '/Trademark/NonCancellation' },
            { name: '答辩与复审', path: '/Trademark/AnswerReview' },
            { name: '监测与维权', path: '/Trademark/Surveillance' }
          ]
        },
        {
          title: '专利申请',
          sub: [
            { name: '检索与撰写', path: '/Patent/SearchWrite' },
            { name: '无效与答辩', path: '/Patent/InvalidationResponse' },
            { name: '转让与许可', path: '/Patent/TransferLicense' },
            { name: '优审与快审', path: '/Patent/FastExamination' },
            { name: '布局与规划', path: '/Patent/Planning' }
          ]
        },
        {
          title: '版权登记',
          sub: [
            { name: '作品登记', path: '/Copyright/Registration' },
            { name: '作品维权', path: '/Copyright/RightsProtection' }
          ]
        },
        {
          title: '知产维权',
          sub: [
            { name: '发明专利维权', path: '/knowledge/InventionPatent' },
            { name: '实用新型专利维权', path: '/knowledge/UtilityPatent' },
            { name: '外观设计专利维权', path: '/knowledge/DesignPatent' },
            { name: '商品商标维权', path: '/knowledge/GoodsTrademark' },
            { name: '服务商标维权', path: '/knowledge/ServiceMark' },
            { name: '著作权维权', path: '/knowledge/CopyrightRights' }
          ]
        },
        {
          title: '动态资讯',
          sub: [
            { name: '全部', path: '/IndustryNews/AllNews' },
            { name: '行业新闻', path: '/IndustryNews/SectorNews' },
            { name: '公司动态', path: '/IndustryNews/CompanyNews' },
            { name: '知识分享', path: '/IndustryNews/KnowledgeSharing' }
          ]
        }
      ]
    }
  },
  computed: {
    // 获取store中的数据,mapStates数组写法
    ...mapState('home', ['activeRoute']),
  },
  methods: {
    //方式二：借助mapMutations 调用commit
    ...mapMutations('home', ['SETACTIVE']),
    // 更改选中下标
    changeActive(i) {
      // console.log(i)
      this.SETACTIVE(i)
      // 隐藏二级菜单
      this.$emit('custom-event', i);
    },
  
  },
  mounted() {
   
  },
}
</script>
<style lang='scss' scoped>
a {
  text-decoration: none;
  color: black;
}

.SubItems {
  position: fixed;
  width: 100vw;
  top: 7rem;
  left: 0;
  z-index: 30;
  border-top: 1px solid #eeecec;
  background-color: white;
  padding: 4vh 3vh 4vh 3vh;
  box-sizing: border-box;
  display: flex;
  overflow: hidden;
  box-shadow: 0 10px 10px rgba($color: #000000, $alpha: 0.3);
}

.popcategory {
  display: flex;
}

.popcategory .imgboxs {
  flex-shrink: 0;
  width: 40vw;
  height: 300px;
  overflow: hidden;
}

.popcategory .imgboxs>img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.categorybox {
  width: 50vw;
  margin-left: 4vw;
  display: flex;
  justify-content: space-between;
}

.categoryitem {
  margin-right: 1vw;
}

.categoryitem div {
  margin-bottom: 0.8rem;
  font-size: 0.85rem;
}

.categoryitem div {
  margin-bottom: 0.8rem;
  font-size: 0.85rem;
}

.title {
  color: #a9a9a9 !important;
  margin-bottom: 1.2rem !important;
  font-size: 1rem !important;
  display: flex;
  align-items: center !important;
}

.sbooicon {
  width: 1rem;
  margin-right: 0.2rem;
}

.categoryitem div:hover {
  color: red;
}

.active {
  color: red !important;
  font-weight: bold;
}

.linkbox {
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.link {
  margin-left: 4vw;
  font-size: 1.6rem;
  font-weight: bold;
  color: red;
}

.logobg {
  z-index: -1;
  position: absolute;
  bottom: -10vw;
  right: -5vw;

  img {
    width: 60vw;
    opacity: 0.05;
  }
}

.grey {
  opacity: 0.5;
}
</style>